import { Box, Text } from '@redriverpress/system'
import { recorderStatus } from 'Common/constants/mediaRecorder'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import RecPlayButton from './RecPlayButton'

export default function Recorder({
  status,
  recordingTime,
  onClick,
  maxSeconds,
  small,
}) {
  const [seconds, setSeconds] = useState(0)

  const recording = status === recorderStatus.RECORDING

  useEffect(() => {
    let mounted = true
    const recordingTimeout = () =>
      setTimeout(() => {
        if (seconds < maxSeconds && mounted) {
          setSeconds(seconds + 1)
        }
      }, 1000)
    if (recording) {
      recordingTimeout()
    }

    return () => {
      mounted = false
      clearTimeout(recordingTimeout)
    }
  }, [seconds, recording])

  return (
    <Box display='flex' alignItems='center'>
      <RecPlayButton
        type='recorder'
        onClick={onClick}
        value={seconds}
        maxValue={maxSeconds}
        icon={recording ? 'stop' : 'microphone'}
        small={small}
      />
      {recordingTime ? (
        <Text
          fontSize={small ? 1 : [4, null, null, 6]}
          ml={2}
          display={small ? ['none', null, 'block'] : 'block'}
        >
          {recordingTime}
        </Text>
      ) : null}
    </Box>
  )
}
Recorder.defaultProps = {
  maxSeconds: 120,
  small: false,
  recordingTime: null,
}

Recorder.propTypes = {
  status: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  recordingTime: PropTypes.string,
  maxSeconds: PropTypes.number,
  small: PropTypes.bool,
}
